import React, { useState, useEffect, useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api } from './api/api';
import { AuthContext } from '../App';

const ALLOWED_ROLES = ['ADMIN', 'UPDATER', 'FORCE_ONE'];

// Track switcher: navigates within the same page via the `id` query param
// (?id={trackId}). Only rendered for ADMIN/UPDATER/FORCE_ONE.
const TrackPicker = ({ currentTrackId }) => {
  const { userRole } = useContext(AuthContext);
  const canSwitch = ALLOWED_ROLES.includes(userRole);
  const [, setSearchParams] = useSearchParams();
  const [tracks, setTracks] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!canSwitch) return;
    let cancelled = false;
    setLoading(true);
    api.get('/track')
      .then(res => {
        if (cancelled) return;
        const sorted = (res.data || []).slice().sort((a, b) => a.name.localeCompare(b.name));
        setTracks(sorted);
      })
      .catch(() => { if (!cancelled) setTracks([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [canSwitch]);

  if (!canSwitch) return null;

  const handleChange = (e) => {
    const id = e.target.value;
    if (!id) return;
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);
      next.set('id', id);
      return next;
    });
  };

  return (
    <select
      className="fb-select"
      style={{ fontSize: 12, padding: '5px 24px 5px 8px', width: 'auto' }}
      value={currentTrackId ?? ''}
      onChange={handleChange}
      disabled={loading}
    >
      <option value="" disabled>{loading ? 'Loading tracks…' : 'Switch track…'}</option>
      {tracks.map(t => (
        <option key={t.id} value={t.id}>{t.name}{t.country ? ` (${t.country})` : ''}</option>
      ))}
    </select>
  );
};

export default TrackPicker;
